import uuid from 'uuid-random';
import { log } from 'log';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useOnClose } from 'js/components/common/PopupManager';
import { useTranslations } from 'js/hooks/i18n';

import { showGeoComplyPopupAction } from '../../../actions';

export const GEOCOMPLY_OOBEE_HINT_POPUP_ID = uuid();

export const useOnSolusHint = ({ sdk, transactionID, setShowOverlay, useTransparentPopup, triggerGeolocation }) => {
    const onClose = useOnClose();
    const dispatch = useDispatch();
    const t = useTranslations();

    return useCallback(async (hint) => {
        log('gcInfo', { transactionID, hint });

        switch (hint.reason) {
            case sdk.HINTS.APP_NOT_OPENED.reason:
                dispatch(showGeoComplyPopupAction({
                    id: GEOCOMPLY_OOBEE_HINT_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: t(`playtech.mobile.system.geocomply.popups.hint.${hint.reason}`, hint.message),
                    isModal: true,
                    buttons: [
                        {
                            onClick: () => {
                                onClose();

                                const { is } = window.GCOobee.utils.browser;
                                const url = is.android ? hint.androidWakeupIntent : hint.iosWakeupUrl;

                                window.location.assign(url);

                                setTimeout(triggerGeolocation, 2000);
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.open',
                            color: 'success'
                        },
                        {
                            onClick: () => {
                                setShowOverlay(false);
                                onClose();
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        }
                    ],
                    useTransparentPopup
                }));
                break;
            case sdk.HINTS.APP_REQUIRED_LOCATION_PERMISSION.reason:
                dispatch(showGeoComplyPopupAction({
                    id: GEOCOMPLY_OOBEE_HINT_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: hint.message,
                    isModal: true,
                    buttons: [
                        {
                            onClick: () => {
                                onClose();

                                window.location.assign(hint.wakeupUrl);

                                setTimeout(triggerGeolocation, 5000);
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.open',
                            color: 'success'
                        },
                        {
                            onClick: () => {
                                setShowOverlay(false);
                                onClose();
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        }
                    ],
                    useTransparentPopup
                }));
                break;
            case sdk.HINTS.APP_REQUIRED_NOTIFICATION_PERMISSION.reason:
                dispatch(showGeoComplyPopupAction({
                    id: GEOCOMPLY_OOBEE_HINT_POPUP_ID,
                    title: 'playtech.mobile.system.geocomply.popups.error.title',
                    content: hint.message,
                    isModal: true,
                    buttons: [
                        {
                            onClick: () => {
                                onClose();

                                window.location.assign(hint.androidNotificationSettingsIntentUri);

                                setTimeout(triggerGeolocation, 5000);
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.openIntent',
                            color: 'success'
                        },
                        {
                            onClick: () => {
                                onClose();

                                window.location.assign(hint.androidNotificationSettingUrl);

                                setTimeout(triggerGeolocation, 5000);
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.openSettings',
                            color: 'success'
                        },
                        {
                            onClick: () => {
                                setShowOverlay(false);
                                onClose();
                            },
                            text: 'playtech.mobile.system.geocomply.popups.error.ignore',
                            color: 'negative'
                        }
                    ],
                    useTransparentPopup
                }));
                break;
            default:
                // noop
        }
    }, [
        t,
        sdk,
        onClose,
        transactionID,
        dispatch,
        setShowOverlay,
        useTransparentPopup,
        triggerGeolocation
    ]);
};
